import {
  PlanPackageDetails,
  SimplePlanPackageDetails,
  SubscriptionDetails,
} from "features/types";
import { filterIneligibleSubscriptions } from "utils/subscriptionUtils";

const getPlanChanges = (
  accountSubscriptions: SubscriptionDetails[],
  selectedFilteredPlanPackage: PlanPackageDetails,
  selectedPlanPackage: SimplePlanPackageDetails
) => {
  return accountSubscriptions
    .filter(
      (sub) =>
        filterIneligibleSubscriptions(sub) &&
        sub.planPackage.id === selectedPlanPackage.id
    )
    .map((sub) => ({
      subscriptionId: sub.id,
      planPackageId: selectedFilteredPlanPackage.id,
    }));
};

export default getPlanChanges;
